import type { ReactNode, Ref } from 'react';

/**
 * Brand Setup's full-height page (web.md §4.1): it renders outside StandardLayout, so it brings its own
 * scroll region, the same one (full width, `py-6`, the `max-w-[1440px] px-6` column) so it lines up with
 * every other page. Its content sits in a 60rem column. `bar`, the wizard's bar, is a flex sibling UNDER
 * the scroll region, so it is always in view and never floats over the content.
 */
export function WizardFrame({
  children,
  bar,
  scrollerRef,
}: {
  children: ReactNode;
  bar?: ReactNode;
  scrollerRef?: Ref<HTMLDivElement>;
}) {
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div ref={scrollerRef} data-page-scroller="" className="min-h-0 flex-1 overflow-y-scroll py-6">
        <div className="mx-auto w-full max-w-[1440px] px-6">
          <div className="mx-auto w-full max-w-[60rem] space-y-4">{children}</div>
        </div>
      </div>
      {bar}
    </div>
  );
}
